import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30454516"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modalBackdrop flex absolute z-max" }
const _hoisted_2 = { class: "c4c-modal" }
const _hoisted_3 = { class: "panelheader" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "headerTitle" }, "Contract Labor and Call Out", -1))
const _hoisted_5 = { "aria-hidden": "true" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text" }, "Close", -1))
const _hoisted_7 = { class: "panleBody" }
const _hoisted_8 = {
  id: "contractlabordetailcount",
  class: "badge bg-success"
}
const _hoisted_9 = {
  id: "calloutstaffdetailcount",
  class: "badge bg-warning"
}
const _hoisted_10 = {
  key: 0,
  id: "contract-labor-home",
  class: "panelTabData scrollBar",
  role: "tabpanel",
  "aria-labelledby": "contract-labor-home-tab"
}
const _hoisted_11 = {
  id: "contractlaborstaffdetail",
  class: "p-2 default-font-size"
}
const _hoisted_12 = {
  key: 1,
  id: "contract-labor-profile",
  class: "panelTabData scrollBar",
  role: "tabpanel",
  "aria-labelledby": "contract-labor-profile-tab"
}
const _hoisted_13 = {
  id: "calloutstaffdetail",
  class: "p-2 default-font-size"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_tab = _resolveComponent("neu-tab")!
  const _component_neu_tablist = _resolveComponent("neu-tablist")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("a", {
          href: "#",
          class: "closeBtn neu-tooltip",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, [
          _createElementVNode("i", _hoisted_5, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'close'],
              size: "lg"
            })
          ]),
          _hoisted_6
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_neu_tablist, {
          value: _ctx.selectedTab,
          class: "mx-4 tabList"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_neu_tab, {
              white: "",
              tab: "ContractLabor",
              onClick: _ctx.showContractLaborDetails
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createTextVNode("Contract Labor "),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.contractLaborCount), 1)
                ])
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_neu_tab, {
              white: "",
              tab: "CallOut",
              onClick: _ctx.showCalloutDetails
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createTextVNode("Call Out "),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.callOutCount), 1)
                ])
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["value"]),
        (_ctx.isContractLaborVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.contractLabors), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isCalloutVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.callOuts), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}